/**
 * Cart Banner Carousel
 * Auto-rotates banner messages in cart drawer
 */

class CartBannerCarousel {
  constructor() {
    this.carousel = document.querySelector('.cart-drawer__banner-carousel');
    if (!this.carousel) return;

    this.items = this.carousel.querySelectorAll('.cart-drawer__banner-item');
    this.dots = this.carousel.querySelectorAll('.cart-drawer__banner-dot');
    this.currentIndex = 0;
    this.autoPlayInterval = null;
    this.autoPlayDelay = 5000; // 5 seconds

    this.init();
  }

  init() {
    // Add click handlers to dots
    this.dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        const index = parseInt(e.currentTarget.dataset.index);
        this.goToSlide(index);
        this.resetAutoPlay();
      });
    });

    // Start auto-play
    this.startAutoPlay();
  }

  goToSlide(index) {
    // Remove active class from current items
    this.items[this.currentIndex]?.classList.remove('active');
    this.dots[this.currentIndex]?.classList.remove('active');

    // Update index
    this.currentIndex = index;

    // Add active class to new items
    this.items[this.currentIndex]?.classList.add('active');
    this.dots[this.currentIndex]?.classList.add('active');
  }

  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.items.length;
    this.goToSlide(nextIndex);
  }

  startAutoPlay() {
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoPlayDelay);
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }

  resetAutoPlay() {
    this.stopAutoPlay();
    this.startAutoPlay();
  }

  destroy() {
    this.stopAutoPlay();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartBannerCarousel();
  });
} else {
  new CartBannerCarousel();
}

// Re-initialize when cart drawer content is updated
document.addEventListener('cart:updated', () => {
  // Small delay to ensure DOM is updated
  setTimeout(() => {
    new CartBannerCarousel();
  }, 100);
});
